import { createSlice, current } from '@reduxjs/toolkit';

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    vender_id:0,
    branch_id:0,
    systemData:{},
    session_id: 0,
    session_year: '',
    session_start_yr: 0,
    session_end_yr: 0,
    session_start_date:'',
    session_end_date:'',
    currentDate:'',
    defaultDate:''
  },

  reducers: {
    setSession: (state, action) => {
      state.vender_id = action.payload.vender_id;
      state.branch_id = action.payload.branch_id;
      state.systemData = action.payload.systemData;
      state.session_id = action.payload.session_id;
      state.session_year = action.payload.session_year;
      state.session_start_yr = action.payload.session_start_yr;
      state.session_end_yr = action.payload.session_end_yr;
      state.session_start_date = action.payload.session_start_date;
      state.session_end_date = action.payload.session_end_date;      
      state.currentDate = action.payload.currentDate;
      state.defaultDate = action.payload.defaultDate;
    },

    
  },
});

export const { setSession } = sessionSlice.actions;

export default sessionSlice.reducer;
